import logo from './logo.svg';
import './App.css';
import Body from './Body';


const App =()=> {
  return (
    <div >
      
      <Body/>
      
    </div>
  );
}

export default App;
